// extracted by mini-css-extract-plugin
export default {"selectBox":"SelectSearch_selectBox__L9atu"};